export default "__VITE_ASSET__aaeb771d__"